module.exports = __webpack_public_path__ + "static/turtle-creek-house04-b2ccb1dd0647591c9616be3c584494c9.jpg";